module.exports = {
    PGSSE_PHASE1_DIAGNOSTIC_DELETE: 'PGSSE_PHASE1_DIAGNOSTIC_DELETE',
    PGSSE_PHASE1_DIAGNOSTIC_CAMPAGNES_DELETE: 'PGSSE_PHASE1_DIAGNOSTIC_CAMPAGNES_DELETE',
    PGSSE_PHASE1_DIAGNOSTIC_CAMPAGNES_FORM_DELETE: 'PGSSE_PHASE1_DIAGNOSTIC_CAMPAGNES_FORM_DELETE',
    PGSSE_PHASE1_DIAGNOSTIC_FORM_DELETE: 'PGSSE_PHASE1_DIAGNOSTIC_FORM_DELETE',
}